import { createState } from '@hookstate/core';
import * as Sentry from '@sentry/react';

export type Suspension = {
    event: string;
    expectedSessionId: number;
    receivedSessionId: unknown;
};

export const suspension = createState<Suspension | null>(null);
const listeners = new Set<() => void>();
let suspended = false;

export const isSuspended = () => suspended;

export const onSuspend = (callback: () => void) => {
    if (suspended) callback();
    else listeners.add(callback);
    return () => {
        listeners.delete(callback);
    };
};

// This latch intentionally has no reset. Only a new page can restore trust.
export const suspendApp = (reason: Suspension) => {
    if (suspended) return;
    suspended = true;
    suspension.set(reason);
    for (const callback of listeners) {
        try {
            callback();
        } catch (error) {
            Sentry.captureException(error);
        }
    }
    listeners.clear();
    Sentry.captureMessage('Game session suspended', {
        level: 'error',
        tags: { event: reason.event },
        extra: reason,
    });
};
